import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';
import {useQueryClient} from '@tanstack/react-query';
import {ordersQueryKeys} from '../hooks/ordersQueryKeys.ts';

// Reload starts again from page 1. The list hook's fetchRecords now loads the NEXT page, so
// Reload invalidates instead of calling it.
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({queryKey: ordersQueryKeys.all});
    };

    return (
        <Box mx='sm'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
